import { render } from "./StudentForm.vue?vue&type=template&id=568037c7&scoped=true"
import script from "./StudentForm.vue?vue&type=script&lang=js"
export * from "./StudentForm.vue?vue&type=script&lang=js"

import "./StudentForm.vue?vue&type=style&index=0&id=568037c7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568037c7"]])

export default __exports__